import React, { useContext } from 'react'
import PropType from 'prop-types'
import { fireGtmEvent } from 'utils/gtm'
import CtaButton from 'components/cta-button'
import WidgetContext from 'components/widget-context'
import styles from './styles.scss'

const SimpleCta = ({ url, variation, variations, utms, large, nmls, onClickHandle }) => {
  const widgetContext = useContext(WidgetContext),
    queryString = Object.keys(utms).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`).join('&'),
    href = `${url}?${queryString}`,
    className = large ? styles.large : styles.small

  return (
    <div className={styles.wrapper}>
      <CtaButton
        href={href}
        className={className}
        onClick={onClickHandle(widgetContext)}
        blank
      >
        {variations[variation]}
      </CtaButton>
      {nmls && <div className={styles.cred}>Credible Operations, Inc. NMLS # 1681276</div>}
    </div>
  )
}

const onClickHandleDefault = widgetContext => () => {
  fireGtmEvent('ctaClick', widgetContext)
}

SimpleCta.propTypes = {
  url: PropType.string.isRequired,
  variation: PropType.string.isRequired,
  variations: PropType.object,
  utms: PropType.object.isRequired,
  large: PropType.bool,
  nmls: PropType.bool,
  onClickHandle: PropType.func,
}

SimpleCta.defaultProps = {
  large: false,
  variations: {
    'compare-rates': 'Compare Rates',
    'find-my-rate': 'Find My Rate',
    'learn-more': 'Learn More',
  },
  nmls: false,
  onClickHandle: onClickHandleDefault,
}

export { SimpleCta, onClickHandleDefault as onClick }

export default SimpleCta
